import { Nil } from "./types";
import { Nullable } from "../types";

export function toNumber(str: string | Nil) {
  const value = parseFloat(str as any);
  // 1.23.45 is valid in parsefloat;
  if (value !== Number(str)) return Number.NaN;
  return value;
}

export function isNumberString(str: Nullable<string>) {
  return !isNaN(toNumber(str));
}

export function toInt(str: string | Nil) {
  const value = toNumber(str);
  return Math.floor(value);
}

export function sum(nums: number[]) {
  return nums.reduce((prev, curr) => prev + curr, 0);
}
